import React, { lazy } from 'react';
import { ShieldCheck, Lock, CheckCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0e0806] border-t border-gold/10" data-id="element-1">
      {/* Return Policy Banner */}
      <div className="bg-green-soft/10 border-b border-green-soft/20 py-4 px-4" data-id="element-2">
        <div className="container-custom text-center" data-id="element-3">
          <p className="text-[14px] text-[#6fcca0] flex items-center justify-center gap-2 flex-wrap" data-id="element-4">
            <span className="text-[18px]" data-id="element-5">🛡️</span>
            <strong data-id="element-6">Garantía de satisfacción:</strong> 7 días para probar el
            protocolo. Si no es lo que esperabas, te devolvemos el 100% de tu
            dinero. Sin preguntas.
          </p>
        </div>
      </div>

      <div className="py-12" data-id="element-7">
        <div className="container-custom" data-id="element-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-10" data-id="element-9">
            <a href="#hero" data-id="element-10">
              <img src="https://i.postimg.cc/VkcMmqSb/logo-284.webp" alt="Reflujo Cero en 72h" className="h-10 w-auto object-contain" loading="lazy" data-id="element-11" />
            </a>

            <div className="flex gap-6 flex-wrap justify-center" data-id="element-12">
              <div className="flex items-center gap-1.5 text-[12px] text-gray" data-id="element-13">
                <Lock className="w-4 h-4 text-gold" data-id="element-14" />
                <span data-id="element-15">SSL Secure</span>
              </div>
              <div className="flex items-center gap-1.5 text-[12px] text-gray" data-id="element-16">
                <CheckCircle className="w-4 h-4 text-gold" data-id="element-17" />
                <span data-id="element-18">Mercado Pago</span>
              </div>
              <div className="flex items-center gap-1.5 text-[12px] text-gray" data-id="element-19">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-20" />
                <span data-id="element-21">Datos Protegidos</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-t border-white/5 pt-8" data-id="element-22">
            <ul className="flex gap-6 list-none flex-wrap justify-center" data-id="element-23">
              <li data-id="element-24">
                <a href="#" className="text-[12px] text-gray hover:text-gold transition-colors" data-id="element-25">
                  Política de Privacidad
                </a>
              </li>
              <li data-id="element-26">
                <a href="#" className="text-[12px] text-gray hover:text-gold transition-colors" data-id="element-27">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-28">
                <a href="#" className="text-[12px] text-gray hover:text-gold transition-colors" data-id="element-29">
                  Política de Reembolsos
                </a>
              </li>
              <li data-id="element-30">
                <a href="#" className="text-[12px] text-gray hover:text-gold transition-colors" data-id="element-31">
                  Contacto
                </a>
              </li>
            </ul>

            <p className="text-[12px] text-gray text-center md:text-right" data-id="element-32">
              © 2024 Hugo Pagano. Todos los derechos reservados.
              <br data-id="element-33" />
              <span className="text-[11px] block mt-1 text-gray/70" data-id="element-34">
                Este producto es material educativo y no reemplaza la consulta
                médica profesional.
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}